import Vue from 'vue'
import {
	ButtonGroup,
	Button,
	Container,
	Header,
	Main,
	Footer,
	Form,
	FormItem,
	Input,
	Aside,
	Menu,
	Submenu,
	MenuItemGroup,
	MenuItem,
	Dropdown,
	DropdownMenu,
	DropdownItem,
	Select,
	Option,
	Table,
	TableColumn,
	Tree,
	DatePicker,
	Pagination,
	Drawer,
	Dialog,
	CascaderPanel,
	Popover,
	InputNumber,
	Progress,
	Radio
} from 'element-ui'

Vue.use(ButtonGroup);Vue.use(Button);Vue.use(Container);Vue.use(Header);Vue.use(Main);Vue.use(Footer);Vue.use(Form);Vue.use(FormItem);Vue.use(Input);Vue.use(Aside);Vue.use(Menu);Vue.use(Submenu);Vue.use(MenuItemGroup);Vue.use(MenuItem);Vue.use(Dropdown);Vue.use(DropdownMenu);Vue.use(DropdownItem);Vue.use(Select);Vue.use(Option);Vue.use(Table);Vue.use(TableColumn);Vue.use(Tree);Vue.use(DatePicker);Vue.use(Pagination);Vue.use(Drawer);Vue.use(Dialog);Vue.use(CascaderPanel);Vue.use(Popover);Vue.use(InputNumber);Vue.use(Progress);Vue.use(Radio);